import './skeleton.css';

export default {
  bind(el) {
    el.classList.add('skeleton');
  },
};
